import React, { Component } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { initializeEreader } from 'PipeRouter';

import CSS from './styles.css';


const Div = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;

  & > iframe {
    height: 100%;
    width: 100%;
  }

  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 768px) {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
`;

let onlyOnce = true;

class VSReader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInitialized: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { ebook, initializeEreader } = nextProps;
    const { vbid, cfi, start, stop } = ebook;
    const { isInitialized } = this.state;

    if (!cfi) {
      return;
    }

    let createObject = {
      vbid,
      cfi,
      el: 'vs-reader',
      highlightsEnabled: true
    };

    if (start && stop) {
      createObject = { ...createObject,
        start: `/${cfi}!/${start}`,
        end: `/${cfi}!/${stop}`
      };
    }

    if (!isInitialized) {
      this.setState({ isInitialized: true });
      initializeEreader(createObject);
    }
  }

  render() {
    const { notifications: { createPageViewerFail, isLoading }} = this.props;
    let hideCSS = `${CSS['hide']}`;

    if (!createPageViewerFail && !isLoading) {
      hideCSS = '';
    }

    return (
      <Div id="vs-reader" className={ hideCSS }/>
    );
  }
}

VSReader.propTypes = {
  initializeEreader: func,
  ebook: shape({
    vbid: string,
    cfi: string,
    begin: string,
    end: string
  }),
  notifications: shape({
    createPageViewerFail: bool,
    isLoading: bool
  })
};


function mapStateToProps(state) {
  const { notifications, reader } = state;

  return {
    ebook: reader.ebook,
    notifications
  };
}

export default connect(mapStateToProps, {
  initializeEreader
})(VSReader);
